module.exports = __webpack_public_path__ + "img/01.4861d551.png";